export default __webpack_public_path__ + "static/media/icon_delete.d0c8bbfe.svg";